import {
  ACCOUNT_TYPE,
  UPGRADE_LINK,
  HOST_NAME,
  ENVIRONMENT,
} from '../common/constant'
// eslint-disable-next-line import/no-nodejs-modules
import { Buffer } from 'buffer'

export function getUpgradeBusinessAccountURL({ accountType: accountType }) {
  let link = ''
  if ([ACCOUNT_TYPE.PERSONAL, ACCOUNT_TYPE.PREMIER].includes(accountType)) {
    link = UPGRADE_LINK.FOR_PERSONAL
  } else if (accountType === ACCOUNT_TYPE.IDENTITY) {
    link = UPGRADE_LINK.FOR_DEVELOPER
  }

  const host =
    ENVIRONMENT.PRODUCTION === process.env.NODE_ENV
      ? HOST_NAME.LIVE
      : HOST_NAME.MSM
  return host + link
}

export function decryptClientId(encryptedClientId) {
  if (encryptedClientId.startsWith('SB:')) {
    encryptedClientId = encryptedClientId.replace('SB:', '')
  }
  return Buffer.from(encryptedClientId, 'base64').toString('utf8')
}
